
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireddd9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireddd9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4MOBe", function(module, exports) {
module.exports = $parcel$import("bn969").then(()=>parcelRequire('jX2IP'));

});

parcelRegister("jXGAI", function(module, exports) {

module.exports = (parcelRequire("7jkLd"))($parcel$resolve("91VDs"));

});
parcelRegister("7jkLd", function(module, exports) {
"use strict";

var $boLNp = parcelRequire("boLNp");
module.exports = $boLNp(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("boLNp", function(module, exports) {
"use strict";
var $84c702df89f2997b$var$cachedBundles = {};
var $84c702df89f2997b$var$cachedPreloads = {};
var $84c702df89f2997b$var$cachedPrefetches = {};
function $84c702df89f2997b$var$getCache(type) {
    switch(type){
        case 'preload':
            return $84c702df89f2997b$var$cachedPreloads;
        case 'prefetch':
            return $84c702df89f2997b$var$cachedPrefetches;
        default:
            return $84c702df89f2997b$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $84c702df89f2997b$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("dlU2j", function(module, exports) {

module.exports = (parcelRequire("7jkLd"))($parcel$resolve("hyngk"));

});

var $111375b4b4d31555$exports = {};
$parcel$extendImportMap({
    "bn969": "dist.988a7c43.js",
    "91VDs": "svgMap.min.fb1986dc.css",
    "hyngk": "svgMapOverwrites.8581c5df.css"
});

const $3589b116af76f95c$var$charCodes = (str)=>str.split('').reverse().map((c)=>c.charCodeAt(0));
class $3589b116af76f95c$var$KeyManager {
    stored = [];
    constructor(phrase, action){
        this.phrase = $3589b116af76f95c$var$charCodes(phrase);
        this.action = typeof action === 'function' ? action : this.action;
    }
    compare() {
        return this.phrase.toString() === this.stored.toString();
    }
    check() {
        this.stored.length > this.phrase.length - 1 && this.stored.pop();
    }
    push(letter) {
        this.stored.unshift(letter);
    }
    action() {
        console.warn("No action implemented");
    }
}
var $3589b116af76f95c$export$2e2bcd8739ae039 = $3589b116af76f95c$var$KeyManager;


var $005783643bf22576$export$2e2bcd8739ae039 = ()=>{
    const infoNode = document.getElementById('info');
    infoNode.style.display = "block";
    return ()=>{
        infoNode.style.display = "none";
    };
};


var $70fa24a0e058d4e6$export$2e2bcd8739ae039 = {
    PL: {
        visited: 1,
        when: 1994,
        what: 'Born here.'
    },
    DE: {
        visited: 1,
        when: [
            2017,
            2017,
            2018
        ],
        what: 'Visiting Berlin with Ola as a part of 2k17 MX-5 Euro trip and then Dota 2 Major in Hanover, also with Ola'
    },
    CZ: {
        visited: 1,
        when: 2017,
        what: 'Visiting Praga with Ola as a part of 2k17 MX-5 Euro trip'
    },
    AT: {
        visited: 1,
        when: 2017,
        what: 'Visiting Vienna with Ola as a part of 2k17 MX-5 Euro trip'
    },
    HU: {
        visited: 1,
        when: [
            2014,
            2015,
            2017
        ],
        what: 'Holidays with parents, year later Formula 1 on Hungaroring, and visiting Budapest with Ola as a part of 2k17 MX-5 Euro trip'
    },
    IT: {
        visited: 1,
        when: [
            2017,
            2019,
            2020
        ],
        what: 'Trip with Sidor\'s and Dawid, snowboarding two years later, and yet a year later snowboarding with Ola'
    },
    SK: {
        visited: 1,
        when: 2015,
        what: "Skis"
    },
    HR: {
        visited: 1,
        when: [
            2014,
            2017
        ],
        what: 'Holidays with parents and then visitng Dubrovnik with Ola as a part of 2k17 MX-5 Euro trip'
    },
    ME: {
        visited: 1,
        when: [
            2015,
            2017
        ],
        what: 'Holidays, fun fact - I met Mirela back then, and then holidays and sightseeing Kotor with Ola as a part of 2k17 MX-5 Euro trip.'
    },
    AL: {
        visited: 1,
        when: 2017,
        what: 'Visiting and sightseeing Tirana with Ola as a part of 2k17 MX-5 Euro trip.'
    },
    BA: {
        visited: 1,
        when: 2017,
        what: 'Visiting and sightseeing Sarajevo with Ola as a part of 2k17 MX-5 Euro trip.'
    },
    DK: {
        visited: 1,
        when: [
            2012,
            2016
        ],
        what: 'Project from secondary school - fun fact - I met Aleksandra there, the second time was a trip with Milosz and Michal (Copenhaga, Bornholm, Christianso)'
    },
    SE: {
        visited: 1,
        when: 2016,
        what: 'Baltic offshore with Milosz and Michal'
    },
    SG: {
        visited: 1,
        when: 2018,
        what: 'Singapure\s airport as a step over of the travel to Sydney'
    },
    AU: {
        visited: 1,
        when: 2018,
        what: 'First company trip to Sydney,'
    },
    QA: {
        visited: 1,
        when: 2018,
        what: 'Doha\s airport as a step over of the travel from Sydney to Poland'
    },
    NL: {
        visited: 1,
        when: 2019,
        what: 'Company trip with Ignat. Watching Ajax in the semi-finals of Champions League.'
    },
    FR: {
        visited: 1,
        when: 2019,
        what: "Holidays in Nice (La c\xf4te d'azur) with Ola"
    },
    MC: {
        visited: 1,
        when: 2019,
        what: "Holidays in Nice (La c\xf4te d'azur) with Ola"
    },
    AX: {
        visited: 1,
        when: 2020,
        what: 'Second sailing on the Balitc Sea with Milosz and Michal'
    },
    FI: {
        visited: 1,
        when: 2020,
        what: 'Visited and stayed on Alands as a part of second sailing on the Balitc Sea with Milosz and Michal'
    },
    EE: {
        visited: 1,
        when: 2020,
        what: 'Visited Kuressaare as a part of second sailing on the Baltic Sera with Milosz and Michal'
    },
    ES: {
        visited: 1,
        when: [
            2021,
            2022
        ],
        what: 'Visited and stayed in Conil de la Frontera for 3 months. City break in Valencia and Madrid (watching Real Madrid vs Real Betis on Santiago Bernabeu)'
    },
    IN: {
        visited: 1,
        when: [
            2026
        ],
        what: 'Visited India - Bengaluru as a business trip with Richard - ITG'
    },
    JP: {
        visited: 1,
        when: [
            2025,
            2026
        ],
        what: 'Visited Japan for the first time with Ola, second time year later with Mama and Ola - the war between Iran, Israel and USA started during the trip. We had to back from USA having trip all around the globe. We have been in Tokyo, Osaka, Hiroshima, Nagoya, Kyoto and many other cities.'
    }
};


const $3bed48ad680034ce$var$isDarkMode = ()=>{
    const t = document.documentElement.dataset.theme;
    if (t) return t === 'dark';
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
};
const $3bed48ad680034ce$var$buildSummary = (overlayNode)=>{
    const summaryNode = overlayNode.querySelector('.summary');
    const main = summaryNode.querySelector('p');
    main.innerHTML = `Visited ${Object.keys((0, $70fa24a0e058d4e6$export$2e2bcd8739ae039)).length} from 195<sup>*</sup> countries.`;
};



var $3bed48ad680034ce$export$2e2bcd8739ae039 = ()=>{
    const overlay = document.querySelector('.overlay');
    $3bed48ad680034ce$var$buildSummary(overlay);
    overlay.style.display = "block";
    Promise.all([
        (parcelRequire("4MOBe")),
        (parcelRequire("jXGAI")),
        (parcelRequire("dlU2j"))
    ]).then(([svgMapModule])=>{
        const SvgMap = svgMapModule.default || svgMapModule;
        new SvgMap({
            targetElementID: 'map',
            colorNoData: $3bed48ad680034ce$var$isDarkMode() ? '#fff' : '#000',
            colorMax: '#888888',
            data: {
                data: {
                    visited: {
                        name: 'Have I visited this country?',
                        thresholdMin: 0,
                        thresholdMax: 1
                    },
                    when: {
                        name: 'When was that happened?',
                        thresholdMin: 1994,
                        thresholdMax: new Date().getFullYear()
                    },
                    what: {
                        name: 'What doing there?'
                    }
                },
                applyData: 'visited',
                values: (0, $70fa24a0e058d4e6$export$2e2bcd8739ae039)
            }
        });
    });
    return ()=>overlay.style.display = "none";
};


// Theme toggle
const $deb2e88c4c8c6e3c$var$effectiveTheme = ()=>document.documentElement.dataset.theme || (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
document.querySelector('.theme-toggle').addEventListener('click', ()=>{
    document.documentElement.dataset.theme = $deb2e88c4c8c6e3c$var$effectiveTheme() === 'dark' ? 'light' : 'dark';
});
const $deb2e88c4c8c6e3c$var$info = new (0, $3589b116af76f95c$export$2e2bcd8739ae039)("info", (0, $005783643bf22576$export$2e2bcd8739ae039));
const $deb2e88c4c8c6e3c$var$map = new (0, $3589b116af76f95c$export$2e2bcd8739ae039)("map", (0, $3bed48ad680034ce$export$2e2bcd8739ae039));
document.addEventListener("keydown", (event)=>{
    if (event.key.length !== 1) return;
    const keyCode = event.key.charCodeAt(0);
    [
        $deb2e88c4c8c6e3c$var$info,
        $deb2e88c4c8c6e3c$var$map
    ].forEach((manager)=>{
        manager.check();
        manager.push(keyCode);
        if (manager.compare()) {
            const disableCb = manager.action();
            document.addEventListener("keydown", disableCb, {
                once: true
            });
        }
    });
});


//# sourceMappingURL=build.a753b484.js.map
